/**
 * Day/Night theme manager.
 *
 * Adds a `theme-day` or `theme-night` class to <html>. Light/dark color
 * overrides live in /app/frontend/src/styles/day-theme.css and key off
 * `html.theme-day` selectors so only daytime mode flips the palette —
 * nighttime keeps the existing dark colors untouched (zero regression).
 *
 * Persists choice to localStorage under THEME_KEY so the rider's
 * selection survives across logout, browser restart, and PWA install.
 */

const THEME_KEY = 'show_master_theme';
export const THEME_DAY = 'day';
export const THEME_NIGHT = 'night';

export const getTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === THEME_DAY ? THEME_DAY : THEME_NIGHT;
  } catch {
    return THEME_NIGHT;
  }
};

export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.classList.remove('theme-day', 'theme-night');
  root.classList.add(theme === THEME_DAY ? 'theme-day' : 'theme-night');
};

export const setTheme = (theme) => {
  try {
    localStorage.setItem(THEME_KEY, theme === THEME_DAY ? THEME_DAY : THEME_NIGHT);
  } catch {
    // Storage disabled — toggle still works for the current session via the class on <html>.
  }
  applyTheme(theme);
};

// Called once at app boot (before React renders) so daytime users don't
// see a flash of dark theme. Wired in /app/frontend/src/index.js.
export const initTheme = () => {
  applyTheme(getTheme());
};
